module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Light.ea4db2bb.woff2";